import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import EditableListTab from 'components/editable-list-tab';
import st from 'core/shared-translations';

const t = defineMessages({
  'client-edit.field.implicitScopes': {
    id: 'client-edit.field.implicitScopes',
    defaultMessage: 'Implicit scope ID',
    description: 'Label for the Implicit Scope ID field',
  },
  'client-edit.field.implicitScopes.placeholder': {
    id: 'client-edit.field.implicitScopes.placeholder',
    defaultMessage: 'Enter implicit scope ID',
    description: 'Placeholder for the Implicit Scope ID field',
  },
});

const ClientImplicitScopesTab = ({
  client,
  canWrite,
  implicitScopes = [],
  onAddImplicitScope,
  onDeleteImplicitScope,
  scopeValidationErrors,
  clearScopeError
}) => {
  const translations = {
    fieldLabel: t['client-edit.field.implicitScopes'],
    fieldPlaceholder: t['client-edit.field.implicitScopes.placeholder'],
    addButtonText: st['shared.add']
  };

  return (
    <EditableListTab
      client={client}
      canWrite={canWrite}
      items={implicitScopes}
      onAddItem={onAddImplicitScope}
      onDeleteItem={onDeleteImplicitScope}
      translations={translations}
      validationErrors={scopeValidationErrors}
      clearScopeError={clearScopeError}
    />
  );
};

ClientImplicitScopesTab.propTypes = {
  client: PropTypes.object.isRequired,
  canWrite: PropTypes.bool,
  implicitScopes: PropTypes.array,
  onAddImplicitScope: PropTypes.func.isRequired,
  onDeleteImplicitScope: PropTypes.func.isRequired,
  scopeValidationErrors: PropTypes.string,
  clearScopeError: PropTypes.func.isRequired,
};

export default ClientImplicitScopesTab;